import createGetFormSyncWarnings from './selectors/getFormSyncWarnings';
import plain from './structure/plain';

export default createGetFormSyncWarnings(plain);


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/redux-form/es/getFormSyncWarnings.js
// module id = 1220
// module chunks = 4